import { db, projectStorage } from '../firebase';


const updateInvoices = (url, reportId) => {
  let error;

  let fileRef = projectStorage.refFromURL(url);

  const collectionRef = db.collection('reports').doc(reportId)
  try {
    collectionRef.delete().then(()=>{
      fileRef.delete().then(()=>{
        console.log('Successfully removed report')
      })
    });
  } catch (error) {
    console.log(error)
  }

  return { error };
}

export default updateInvoices;